module.exports = __webpack_public_path__ + "static/media/wizualizacja-88.8809311e.png";